// blob-error.interceptor.ts
import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CustomMessageService } from '../shared/services/customPriemngMessage.service';

@Injectable()
export class BlobErrorInterceptor implements HttpInterceptor {
  private messageService = inject( CustomMessageService );


  intercept ( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    return next.handle( req ).pipe(
      catchError( ( error: HttpErrorResponse ) => {
        // ErrorInterceptor owns the 429 message (one per burst, with Retry-After)
        if ( req.headers.get( 'Skip-Error-Toast' ) === 'true' || error.status === HttpStatusCode.TooManyRequests ) {
          return throwError( () => error );
        }
        // Handle blob error responses
        if ( error.error instanceof Blob && !( error.error instanceof ArrayBuffer ) ) {
          return from( this.readBlobAsText( error.error ) ).pipe(
            switchMap( errorText => {
              let errorMessage = 'An error occurred';
              
              try {
                // Try to parse as JSON if it's JSON error response
                const errorObj = JSON.parse( errorText );
                errorMessage = errorObj.message || errorText;
              } catch {
                // If not JSON, use the text as is
                errorMessage = errorText || `Request failed with status ${error.status}`;
              }

              // Show error message to user
              this.messageService.error( { message: errorMessage } );
              
              // Re-throw the error with the parsed message
              return throwError( () => error );
            } )
          );
        }
        
        // Handle non-blob errors
        const errorMessage = error.message || `Request failed with status ${error.status}`;
        this.messageService.error( { message: errorMessage } );
        return throwError( () => error );
      } )
    );
  }

  // Helper method to read blob as text
  private readBlobAsText ( blob: Blob ): Promise<string> {
    return new Promise( ( resolve, reject ) => {
      const reader = new FileReader();
      reader.onload = () => resolve( reader.result as string );
      reader.onerror = () => reject( reader.error );
      reader.readAsText( blob );
    } );
  }
}